import type { Infer } from 'superstruct';
import { object, string } from 'superstruct';
import { notEmpty } from '../../../../form';

export const CodeFormValidation = object({
  code: notEmpty(string()),
});

export type CodeFormFields = Infer<typeof CodeFormValidation>;
